export default __webpack_public_path__ + "static/media/metamask-setup_image_1.93d583aa.jpg";